import { useTranslation } from 'react-i18next';

type OrdersCountLineProps = {
  readonly shown: number;
  readonly total: number;
  readonly filtered: boolean;
};

export function OrdersCountLine({
  shown,
  total,
  filtered,
}: OrdersCountLineProps) {
  const { t } = useTranslation('order');

  return (
    <div data-testid="orders-count-line" className="text-sm text-neut-600">
      {filtered
        ? t('order.filter.showing', { shown, total })
        : t('order.filter.order_count', { count: total })}
    </div>
  );
}
